import Layout from '@/layout/paycools-index.vue'
// import i18n from '@/lang'

export const onlinePaymentShowRouter = {
  path: '/kyc',
  component: Layout,
  redirect: '/onlinePayment/paymentLink',
  name: 'Online_Transaction',
  meta: { title: 'online_payment', icon: 'payment-link' },
  children: [
    {
      path: '/kyc',
      name: 'Online_Transaction_Payment_Link',
      component: () => import('@/views/paycools/kyc/KycIndex.vue'),
      meta: {
        title: 'payment_link', noCache: false,
        auth: ['AUTH_CODE_DATA_BOARD']
      },
      hidden: true
    }
  ]
}
